const o = {
  default: 0,
  thousand: 1e3,
  million: 1e6,
  billion: 1e9
}, m = (t, r) => new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: r
}).format(t), l = (t, r = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: r
}).format(t / o.thousand)}K`, f = (t, r = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: r
}).format(t / o.million)}M`, d = (t, r = 2) => `${new Intl.NumberFormat("en-US", {
  style: "decimal",
  maximumFractionDigits: r
}).format(t / o.billion)}B`, b = (t, r) => {
  const e = Math.abs(t);
  return e >= o.billion ? d : e >= o.million ? f : r && e >= o.thousand ? l : m;
}, i = ({
  number: t,
  maximumFractionDigits: r,
  shorten: e = !0,
  formatThousands: n = !1,
  signIndicator: a = !1
}) => {
  const s = Math.abs(t), u = () => t ? a ? t < 0 ? "-" : "+" : t < 0 ? "-" : "" : "", c = e ? b(s, n) : m;
  return `${u()}${c(s, r)}`;
}, h = (t, r = 1, e = !1) => t === 0 ? "0" : Math.abs(t) < 0.5 ? t < 0 ? ">-0.5" : `<${e ? "+" : ""}0.5` : `${e && t > 0 ? "+" : ""}${i({
  number: t,
  maximumFractionDigits: r
})}`, F = (t) => Number(t.toFixed(0)), N = (t) => new Intl.NumberFormat("en-US").format(t), $ = (t, r = 0, e = "$", n = !1, a = !1, s = !1) => `${e}${i({ number: t, maximumFractionDigits: r, shorten: n, formatThousands: a, signIndicator: s })}`, M = (t) => {
  const r = t % 10, e = t % 100;
  return r === 1 && e !== 11 ? t + "st" : r === 2 && e !== 12 ? t + "nd" : r === 3 && e !== 13 ? t + "rd" : t + "th";
}, g = (t, r = !1) => t != null && !isNaN(t) && (r || t !== 0), T = (t, r = 4) => {
  const e = "0", n = (t / 100).toFixed(r), a = n.substring(n.indexOf(".")).length;
  return n + e.repeat(Math.max(r - a, 0));
}, x = (t) => Math.trunc(t), w = (t, r = 4) => {
  const e = t / 100;
  return e < 0.01 ? t.toFixed(r) : new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: r
  }).format(e);
}, I = (t, r = "%", e = 1) => `${t.toFixed(e)}${r}`, D = ({
  percentage: t,
  fractionDigits: r = 1,
  signIndicator: e
}) => `${i({ number: t, maximumFractionDigits: r, shorten: !1, signIndicator: e })}%`, U = (t, r = "auto") => {
  const e = Math.abs(t);
  let n = 1e3;
  for (; t; ) {
    if (e / n < 1)
      return t;
    if (e / n < 1e3)
      switch (r) {
        case "up":
          return Math.ceil(t / n) * n;
        case "down":
          return Math.floor(t / n) * n;
        default:
          return Math.round(t / n) * n;
      }
    n = n * 1e3;
  }
  return t;
};
export {
  o as MAGNITUDES,
  F as calcFractionToPercentagesNumber,
  T as convertPercentageToDecimal,
  w as convertPercentageToDecimalV2,
  $ as currencyFormat,
  d as formatBillions,
  m as formatDefault,
  f as formatMillions,
  D as formatNumberToPercentage,
  I as formatNumberWithFractionDigits,
  l as formatThousands,
  g as isValidNumber,
  i as numberFormat,
  N as numberFormatCommas,
  M as ordinalNumberFormatter,
  h as percentageFormat,
  U as roundToWholeNumber,
  x as scoreToPercentage
};
//# sourceMappingURL=index.es552.js.map
